import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { InAppNotification, InAppNotificationCreate, InAppNotificationFilter } from '../data/inAppNotification';

export function createInAppNotificationService(client: AxiosInstance) {
  return createCrudService<InAppNotification, InAppNotificationCreate, InAppNotificationFilter>(
    client,
    '/notifications/InAppNotification',
    'id',
  );
}

export type InAppNotificationService = CrudService<InAppNotification, InAppNotificationCreate, InAppNotificationFilter>;
